import React, { useState } from "react";
import { GrView } from "react-icons/gr";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
export const DepartmentList = ({ courses = [], BeURL, reload }) => {

    const [selectedDept, setSelectedDept] = useState(null);
    const [editName, setEditName] = useState("");

    /* ================= DELETE ================= */
    const handleDelete = async (id) => {

        if (!window.confirm("Are you sure delete this department ?")) return;

        try {
            const res = await fetch(`${BeURL}/delete-department/${id}`, {
                method: "DELETE",
                credentials: "include"
            });

            const data = await res.json();

            if (data.success) {
                reload && reload();
            }
        } catch (err) {
            console.log(err);
        }
    };

    /* ================= EDIT ================= */
    const handleUpdate = async () => {

        if (!editName.trim()) {
            alert("Enter department name");
            return;
        }

        try {

            const res = await fetch(`${BeURL}/update-department/${selectedDept._id}`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    department: editName.trim()
                })
            });

            const data = await res.json();
            if (data.success) {
                alert("Department Updated");
                setSelectedDept(null);
                reload && reload();
            } else {
                alert(data.message || "Update failed");
            }

        } catch (err) {
            console.log(err);
            alert("Server error");
        }
    };

    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm">
                <thead className="bg-primary-100 text-xs capitalize text-primary-600">
                    <tr>
                        <th className="p-3 border">Sl.No</th>
                        <th className="p-3 border">Code</th>
                        <th className="p-3 border">Name</th>
                        <th className="p-3 border">Created</th>
                        <th className="p-3 border">Updated</th>
                        <th className="p-3 border">Action</th>
                    </tr>
                </thead>

                <tbody>
                    {courses.map((d, index) => (
                        <tr key={d._id} className="border-t text-center">

                            <td className="p-3 border">{index + 1}</td>

                            <td className="p-3 border font-semibold text-blue-600">
                                {d.code}
                            </td>

                            <td className="p-3 border">
                                {d.department}
                            </td>

                            <td className="p-3 border">
                                {new Date(d.createdAt).toLocaleDateString("en-IN")}
                            </td>

                            <td className="p-3 border">
                                {new Date(d.updatedAt).toLocaleDateString("en-IN")}
                            </td>

                            {/* ACTION BUTTONS */}
                            <td className="p-3 border">
                                <div className="flex gap-2 justify-center">

                                    {/* VIEW */}
                                    <button
                                        onClick={() => setSelectedDept({ ...d, mode: "view" })}
                                        className="rounded text-xs text-primary-600"
                                    >
                                        <GrView  size={20}/>
                                    </button>

                                    {/* EDIT */}
                                    <button
                                        onClick={() => {
                                            setSelectedDept({ ...d, mode: "edit" });
                                            setEditName(d.department);
                                        }}
                                        className="rounded text-xs text-yellow-600"
                                    >
                                        <FaEdit size={20} />
                                    </button>

                                    {/* DELETE */}
                                    <button
                                        onClick={() => handleDelete(d._id)}
                                        className="text-red-600 rounded text-xs"
                                    >
                                        <MdOutlineDeleteOutline  size={20}/>
                                    </button>

                                </div>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>

            {/* ================= POPUP ================= */}

            {selectedDept && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

                    <div className="bg-white p-6 rounded w-[400px] space-y-4">

                        <div className="flex justify-between">
                            <h3 className="font-semibold text-lg">
                                {selectedDept.mode === "edit"
                                    ? "Edit Department"
                                    : "Department Details"}
                            </h3>

                            <button onClick={() => setSelectedDept(null)}>✕</button>
                        </div>

                        <div className="text-sm space-y-2">

                            <p><b>Code:</b> {selectedDept.code}</p>

                            {selectedDept.mode === "edit" ? (

                                <input
                                    value={editName}
                                    onChange={(e) => setEditName(e.target.value)}
                                    className="w-full border p-2 rounded"
                                />

                            ) : (

                                <p><b>Name:</b> {selectedDept.department}</p>

                            )}

                            <p>
                                <b>Created:</b>{" "}
                                {new Date(selectedDept.createdAt).toLocaleDateString("en-IN")}
                            </p>

                        </div>

                        {/* BUTTONS */}
                        <div className="flex justify-end gap-3">

                            <button onClick={() => setSelectedDept(null)}>
                                Close
                            </button>

                            {selectedDept.mode === "edit" && (
                                <button
                                    onClick={handleUpdate}
                                    className="bg-green-600 text-white px-4 py-1 rounded"
                                >
                                    Update
                                </button>
                            )}

                        </div>

                    </div>

                </div>
            )}

        </div>
    );
};